import Vue from 'vue';

import {
  mapMutations,
  mapGetters,
} from 'vuex';

export default {
  name: 'LanguageSwitch',
  components: {},
  props: {},
  data: () => ({
    isOpen: false,
    language: 'nl',
  }),
  computed: {
    ...mapGetters('appointment', {
      getLang: 'getLanguage',
    }),
  },
  methods: {
    ...mapMutations('appointment', {
      setLanguageMutation: 'SET_LANGUAGE',
    }),
    toggle() {
      this.isOpen = !this.isOpen;
    },
    setLanguage(languageCode, languageString) {
      this.language = languageString;
      this.isOpen = false;
      Vue.config.language = languageCode;
      this.setLanguageMutation(languageString);
    },
  },
  created() {
    if (Vue.config.language === 'fr_BE') {
      this.language = 'fr';
    }
  },
};
